import React, { useMemo, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    getPriceRequest,
    getRaisedDataByID,
    getGroups,
} from 'redux/datasource/dataSourceSlice';
import {
    getAllGroups,
    getAllPriceRequests,
    getPriceReqRaisedDataByID,
} from 'redux/datasource/dataSourceActions';
import { useSelector } from 'react-redux';
import { useCommonInits } from 'hooks/useCommonInits';
import { getUser, getUnitIds } from 'redux/auth/authSlice';
import {
    Grid,
    Typography,
    Paper,
    FormControl,
    Select,
    MenuItem,
    Button,
} from '@mui/material';
import RequestPageIcon from '@mui/icons-material/RequestPage';

export const PriceReqStatic = () => {
    const priceRequest = useSelector(getPriceRequest);
    const user = useSelector(getUser);
    const { dispatch } = useCommonInits();
    const [pageSize, setPageSize] = useState(10);
    const getRaisedData = useSelector(getRaisedDataByID);
    const [group, setGroup] = useState('ALL');
    const [filteredAssetData, setFilteredAssetData] = useState(
        user.app_type.includes('APCM') ? priceRequest : getRaisedData,
    );
    const getGroup = useSelector(getGroups);
    const units = useSelector(getUnitIds);
    const unitIds = JSON.parse(units);
    const filteredGroups = getGroup?.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });
    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 2;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                // width: '22%',
            },
        },
    };
    const getFilteredData = () => {
        if (user.app_type.includes('APCM')) {
            if (group === 'ALL') {
                return priceRequest;
            } else {
                return priceRequest.filter(data => data.group_name === group);
            }
        } else {
            if (group === 'ALL') {
                return getRaisedData;
            } else {
                return getRaisedData.filter(data => data.group_name === group);
            }
        }
    };

    useEffect(() => {
        dispatch(getAllGroups());
        dispatch(getAllPriceRequests());
    }, []);

    useEffect(() => {
        if (!user.app_type.includes('APCM')) {
            if (getGroup) {
                const params = {
                    group_id: filteredGroups.map(group => group._id),
                };
                dispatch(getPriceReqRaisedDataByID(params));
            }
        }
    }, [getGroup]);

    const columns = useMemo(
        () => [
            {
                field: 'date_time',
                headerName: 'Date Time For Execution',
                width: 350,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'group_name',
                headerName: 'Group Name',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'old_price',
                headerName: 'Old Price',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price',
                headerName: 'New Price',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'confirmed',
                headerName: 'Confirmed',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
        ],
        [],
    );
    return (
        <div>
            <Paper sx={{ margin: 2 }}>
                <div>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        sx={{ p: 2 }}
                    >
                        <Grid item>
                            <RequestPageIcon fontSize="large" />
                        </Grid>
                        <Grid item sx={{ pl: 1 }}>
                            <Typography variant="h5">
                                Raised Price Requests
                            </Typography>
                        </Grid>
                    </Grid>
                    <label style={{ marginLeft: '20px', marginRight: '5px' }}>
                        Groups :
                    </label>
                    <FormControl>
                        <Select
                            size="small"
                            value={group || 'ALL'}
                            onChange={e => setGroup(e.target.value)}
                            sx={{
                                width: 250,
                                marginBottom: '5px',
                                marginRight: '5px',
                            }}
                            MenuProps={MenuProps}
                        >
                            <MenuItem value={'ALL'}>ALL</MenuItem>
                            {user.app_type.includes('APCM')
                                ? getGroup.map(item => {
                                      return (
                                          <MenuItem
                                              value={item.name}
                                              key={`interval-${item.name}`}
                                          >
                                              {item.name}
                                          </MenuItem>
                                      );
                                  })
                                : filteredGroups.map(item => {
                                      return (
                                          <MenuItem
                                              value={item.name}
                                              key={`interval-${item.name}`}
                                          >
                                              {item.name}
                                          </MenuItem>
                                      );
                                  })}
                        </Select>
                    </FormControl>
                    {/* <Button
                        variant="outlined"
                        onClick={() => handleAssets()}
                        style={{ margin: '2px' }}
                    >
                        Get Request
                    </Button> */}
                </div>
            </Paper>

            <Paper sx={{ margin: 2 }}>
                <DataGrid
                    disableColumnMenu
                    rows={getFilteredData()}
                    columns={columns}
                    getRowId={row => row._id}
                    rowsPerPageOptions={[10, 25, 50]}
                    autoHeight={true}
                    pageSize={pageSize}
                    onPageSizeChange={newPage => setPageSize(newPage)}
                    getRowSpacing={params => ({
                        top: params.isFirstVisible ? 0 : -2,
                        bottom: params.isLastVisible ? 0 : -2,
                    })}
                />
            </Paper>
        </div>
    );
};
